import { ChatInterface } from '@/components/ChatInterface';

export function Chat() {
  return (
    <div className="h-[calc(100vh-8rem)] mx-auto max-w-3xl">
      <ChatInterface />
    </div>
  );
}

